export default "__VITE_ASSET__Bw306Qiq__"